import React from 'react'

export const EditIcon = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="18"
    height="18"
    fill="none"
    viewBox="0 0 18 18"
  >
    <g fill="#000" clipPath="url(#clip0_146_678)">
      <path d="M12.938 17.999H2.063A2.064 2.064 0 010 15.936V5.061C0 3.923.925 3 2.063 3h6.374a.563.563 0 010 1.125H2.064a.939.939 0 00-.938.937v10.875c0 .517.42.938.938.938h10.874c.517 0 .938-.421.938-.938V9.561a.563.563 0 011.125 0v6.375a2.064 2.064 0 01-2.063 2.063z" />
      <path d="M6.579 11.982a.561.561 0 01-.551-.673l.53-2.652a.56.56 0 01.153-.287L14.48.603a2.065 2.065 0 012.917 0c.39.39.604.907.604 1.458 0 .551-.215 1.069-.605 1.458l-7.767 7.768a.559.559 0 01-.287.153l-2.651.53a.55.55 0 01-.111.012zm2.652-1.093h.007-.007zM7.627 9.045l-.33 1.658 1.656-.332L16.6 2.724a.933.933 0 00.275-.663.94.94 0 00-1.6-.663L7.626 9.045z" />
      <path d="M15.937 4.745a.558.558 0 01-.397-.165L13.419 2.46a.563.563 0 01.795-.796l2.121 2.122a.562.562 0 01-.398.96z" />
    </g>
    <defs>
      <clipPath id="clip0_146_678">
        <path fill="#fff" d="M0 0H18V18H0z" />
      </clipPath>
    </defs>
  </svg>
)
